<template>
  <mobile-tooltip top v-if="text.length">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="error"
        v-bind="attrs"
        v-on="on"
        :x-small="size == 'x-small'"
      >
        <v-icon>error</v-icon>
      </v-btn>
    </template>
    <div class="pb-2">
      <div class="pt-2 px-2" v-for="(item, i) in text" :key="i">{{ item }}</div>
    </div>
  </mobile-tooltip>
</template>

<script>
import moment from "moment";
export default {
  name: "UrgentCheckInIcon",
  props: {
    size: { type: String, default: "medium" },
    checkin: { type: Object },
    talkingPoint: { type: Object },
    simpleCheckin: { type: Object }
  },
  computed: {
    text() {
      let values = [];
      if (this.checkin) {
        let hasUrgentTalkingPoints = this.checkin.talkingPoints.filter(
          x => x.isUrgent
        ).length;
        if (hasUrgentTalkingPoints > 0) {
          values.push("Urgent Talking Point");
        }

        let pastDueActionItems =
          this.checkin.pastActionItems.filter(x => moment() > moment(x.dueDate))
            .length +
          this.checkin.actionItems.filter(x => moment() > moment(x.dueDate))
            .length;
        if (pastDueActionItems > 0) {
          values.push("Past Due Action Item");
        }

        let dueGoals = (this.checkin.goals || []).filter(
          x => x.completeDate == null && moment() > moment(x.dueDate)
        ).length;
        if (dueGoals > 0) {
          values.push("Past Due Goal");
        }
      } else if (this.talkingPoint) {
        if (this.talkingPoint.isUrgent) {
          values.push("Urgent Talking Point");
        }
      } else if (this.simpleCheckin) {
        if (this.simpleCheckin.hasUrgentTalkingPoint) {
          values.push("Urgent Talking Point");
        }
        if (this.simpleCheckin.pastDueActionItems > 0) {
          values.push("Past Due Action Item");
        }
        if (this.pastDueGoals > 0) {
          values.push("Past Due Goal");
        }
      }
      return values;
    }
  }
};
</script>
